import { DealernetApi } from "./DealernetApi";

import { ICarouselAdDto } from "@/types";


export class CarouselService {

    public static async getActiveCarouselAds(): Promise<ICarouselAdDto| undefined> {
        const response = await DealernetApi.client().get("/Carousel/GetActiveCarouselAds");
        return response;
    }
}